import React from 'react'
import MegaInfoCard from './Megaschool/MegaInfoCard'
import { megaschoolInfoItem } from '@/assets/data/megaschool'
import Image from 'next/image'
import map from '@/assets/img/for-farmers/for-farmers-map.png'

const ForFarmers = () => {
    return (
        <div className='for-farmers'>
            <div className="for-farmers__map">
                <Image src={map} width={1648} height={1106} quality={100} alt='map' />
            </div>
            <MegaInfoCard type='megatravel' item={megaschoolInfoItem[1]} />
        </div>
    )
}

export default ForFarmers
